<template>
  <v-card rounded flat class="pb-2">
    <v-row justify="center" class="purpleContainer">
      <v-card height="580" rounded="xl" width="1280">
        <v-img
          src="/images/purpleSonar.png"
          height="580"
          class="rounded-xl"
        ></v-img>
        <div class="cardText">
          <h1
            v-if="data"
            class="text2 white--text sigflo-xl mb-4"
            v-html="replaceColorMarkup(data.title)"
          ></h1>
          <div class="text3 sigflo-body mutedWhiteText mb-8" v-if="data">
            {{ data.webDescription }}
          </div>
          <div v-if="!data" class="text2 white--text sigflo-xl mb-4">
            Loading...
          </div>
          <v-btn
            v-if="data"
            outlined
            color="white"
            rounded
            dark
            width="300"
            height="76"
            class="button1"
            @click="openSystem(data.projectTemplateId, data)"
            >Start Building</v-btn
          >
        </div>
      </v-card>
      <div class="venueHeaderImage" v-if="data">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="402"
          height="402"
          viewBox="0 0 402 402"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M402 46.5295C402 20.832 381.168 0 355.47 0H100.5C79.7893 0 63 16.7893 63 37.5V43.5C63 60.897 48.897 75 31.5 75C14.103 75 0 89.103 0 106.5V355.47C0 381.168 20.832 402 46.5295 402H289.5C310.763 402 328 384.763 328 363.5V362C328 341.565 344.565 325 365 325C385.435 325 402 308.435 402 288V46.5295Z"
            fill="#340072"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M402 46.5295C402 20.832 381.168 0 355.47 0H100.5C79.7893 0 63 16.7893 63 37.5V43.5C63 60.897 48.897 75 31.5 75C14.103 75 0 89.103 0 106.5V355.47C0 381.168 20.832 402 46.5295 402H289.5C310.763 402 328 384.763 328 363.5V362C328 341.565 344.565 325 365 325C385.435 325 402 308.435 402 288V46.5295Z"
            :fill="'url(#' + patternId + ')'"
          />

          <defs>
            <pattern
              :id="patternId"
              patternUnits="userSpaceOnUse"
              width="402"
              height="402"
            >
              <image
                :id="imageId"
                class="venueImage"
                width="402"
                height="402"
                :xlink:href="data.tileImage"
                preserveAspectRatio="xMidYMid slice"
              />
            </pattern>
          </defs>
        </svg>
      </div>
    </v-row>
  </v-card>
</template>

<script>
  export default {
    props: {
      data: Object
    },
    data() {
      const id = this.data ? this.data.id : 0;
      return {
        patternId: `pattern_${id}`,
        imageId: `image_${id}`
      };
    }
  };
</script>

<style scoped>
  .purpleContainer {
    position: relative;

    flex-shrink: 0;
  }
  .cardText {
    position: absolute;
    top: 100px;
    left: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .text2 {
    width: 623px;
    line-height: 72px;
    /* flex-direction: column;
    justify-content: center; */
    flex-shrink: 0;
  }
  .text3 {
    width: 427px;
    font-feature-settings: 'clig' off, 'liga' off;
  }

  .button1 {
    font-weight: 600;
    font-family: 'Inter V';
    font-size: 24px;
    border-radius: 38px;
  }
  .venueHeaderImage {
    position: absolute;
    right: 160px;
    top: 100px;
  }
  .venueIcon {
    position: absolute !important;
    top: 5px;
    left: 5px;
    z-index: 5;
  }
</style>
